const ADDITIONAL_PRODUCT_DETAILS_ACCORDION = (() => {
  const checkForAvailableDetails = () => {
    const nodes = document.querySelectorAll('div[class^="additional-product-details_2__"]');
    if(nodes.length === 0) {
      const parent = document.querySelector('.additional-product-details-accordion-wrapper')
      parent.classList.add('hidden')
    }
  }
  return {
    checkForAvailableDetails,
  };
})();